module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Yeti-82d6e919f921acd6d9851474ac359869.png";